import config from '../config';

const imageSrcFromId = (id, thumb = false, suffix = '') => {
  if (!id) return null;

  if (thumb) {
    return config.town.back.media.image.thumb
            + id
            + suffix;
  }

  return config.town.back.media.image.get
          + id
          + suffix;
};

export default imageSrcFromId;
